import { render, staticRenderFns } from "./LatestNewsAnnouncements.vue?vue&type=template&id=76bc5612&scoped=true"
import script from "./LatestNewsAnnouncements.vue?vue&type=script&lang=js"
export * from "./LatestNewsAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./LatestNewsAnnouncements.vue?vue&type=style&index=0&id=76bc5612&prod&lang=scss"
import style1 from "./LatestNewsAnnouncements.vue?vue&type=style&index=1&id=76bc5612&prod&lang=scss&scoped=true"
import style2 from "./LatestNewsAnnouncements.vue?vue&type=style&index=2&id=76bc5612&prod&lang=scss&scoped=true"
import style3 from "./LatestNewsAnnouncements.vue?vue&type=style&index=3&id=76bc5612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc5612",
  null
  
)

export default component.exports